import { useState } from "react";
import { CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function AIRAACommitment() {
  const { t } = useTranslation(); // Translation Hook
  const [showAll, setShowAll] = useState(false);

  const commitments = [
    "Bridge Between MEA and Recruitment Agencies – Serve as a link between the Ministry of External Affairs (MEA) and overseas recruitment companies to streamline policies and processes.",
    "Candidate Support & Guidance – Assist candidates traveling abroad with pre-departure training, legal documentation, and grievance redressal.",
    "Regulatory Compliance & Advocacy – Ensure all member agencies comply with MEA regulations and advocate for policy improvements.",
    "Ethical Recruitment Practices – Promote transparency and fair recruitment policies to prevent exploitation and human trafficking.",
    "Skill Development & Certification – Partner with government and private institutions to provide training and certification for overseas job seekers.",
    "Digital Transformation & Technology Adoption – Encourage the use of digital platforms for recruitment, verification, and documentation to enhance efficiency.",
    "Employment Market Research & Trends – Provide insights into global labor market trends to help agencies make informed decisions",
    "Dispute Resolution & Legal Assistance – Offer mediation and legal support to resolve conflicts between candidates, agencies, and employers.",
    "Collaboration with Foreign Governments – Establish strong ties with overseas labor ministries for better job opportunities and worker welfare.",
    "Protecting Indian Worker's Rights – Ensure the safety, dignity, and rights of Indian workers abroad through agreements with foreign employers.",
    "Emergency Support for Migrant Workers – Set up a helpline and rapid response team to assist workers in distress abroad.",
    "Recognition & Accreditation of Recruitment Agencies – Establish a rating system for agencies to maintain credibility and quality standards.",
    "Preventing Fraudulent Recruitment – Work with authorities to eliminate fake recruitment agencies and prevent illegal job offers",
    "Welfare Programs & Social Security – Advocate for the inclusion of Indian migrant workers in host countries’ social security programs.",
    "Regular Workshops & Training for Agencies – Conduct sessions on legal frameworks, international job markets, and ethical recruitment.",
    "Women & Vulnerable Worker Protection – Ensure special safeguards for female and low-skilled workers to prevent exploitation.",
    "Industry Growth & International Competitiveness – Position Indian recruitment agencies as global leaders in ethical and skilled workforce deployment.",
  ];

  const displayedCommitments = showAll ? commitments : commitments.slice(0, 5);

  return (
    <section>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto text-center"
      >
        <h2 className="text-4xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl font-extrabold mb-6 text-green-600 leading-tight">
          AIRAA'S <span className="text-blue-900">Commitment</span>
        </h2>
      </motion.div>
      <div className="mx-auto">
        <motion.ul
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="space-y-6"
        >
          {displayedCommitments.map((commitment, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="flex items-start space-x-4 bg-white p-6 rounded-xl shadow-lg transform hover:scale-100 transition duration-300 border-l-4 border-green-500 hover:border-blue-500 hover:shadow-xl"
            >
              <CheckCircle className="text-green-500 w-8 h-8 flex-shrink-0" />
              <p className="text-gray-800 text-lg font-medium leading-relaxed">
                {commitment}
              </p>
            </motion.li>
          ))}
        </motion.ul>
        {!showAll && (
          <div className="text-center mt-6">
            <button
              onClick={() => setShowAll(true)}
              className="bg-green-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-green-700 transition duration-300 cursor-pointer"
            >
              Show More
            </button>
          </div>
        )}
      </div>
    </section>
  );
}